export default "__VITE_ASSET__CJnpAigJ__"